<script>
import p5 from "p5";
import p5sound from "p5/lib/addons/p5.sound";

export default {
  name: "P5vue",
  mounted() {
    this.uid = `p5-${Math.round(Math.random() * 10000)}`;
    this.p5 = new p5((p) => {
      this.sketch(p, this);
    }, this.$refs.p5);

  },
  props: ["color"],
  methods: {
    sketch: (sketch, vueThis) => {
      let mic, canvas, amplitude, fft, osc;

      const w = vueThis.$refs.p5.getBoundingClientRect().width;

      sketch.setup = function () {
        sketch.angleMode(sketch.DEGREES);
        sketch.rectMode(sketch.CENTER);
        canvas = sketch.createCanvas(w, w);
        mic = new p5.AudioIn();
        amplitude = new p5.Amplitude();
        fft = new p5.FFT();
        osc = new p5.Oscillator();
        osc.amp(0.5);

        amplitude.setInput(mic);
        fft.setInput(mic);

        mic.start();
      };

      sketch.touchStarted = function () {
        sketch.getAudioContext().resume();
      };

      let volHistory = [];

      sketch.draw = function () {
        // Get the overall volume (between 0 and 1.0)
        sketch.clear();
        const vol = mic.getLevel();
        volHistory.push(vol);
        const spectrum = fft.analyze();

        const rms = amplitude.getLevel();
        const h = sketch.map(sketch.vol, 0, 1, sketch.height * 0.5, 0);
        sketch.stroke(0, 0, 0, 255);

        sketch.push();

        sketch.translate(sketch.width * 0.5, sketch.height * 0.5);

        sketch.noStroke();
        sketch.rotate(-90 + sketch.frameCount * -0.095);
        sketch.beginShape();

        sketch.fill(255, 10);
        spectrum.splice(0, 100);
        spectrum.splice(
          spectrum.length - spectrum.length * 0.96,
          spectrum.length * 0.96 - 1
        );

        let mirroredSpect = [...spectrum].concat(spectrum.reverse());

        for (let i = 0; i < mirroredSpect.length; i++) {
          let r =
            sketch.map(vol, 0, 1, 20, 0) +
            sketch.map(
              mirroredSpect[i],
              0,
              255,
              sketch.width * 0.2,
              sketch.width * 0.5
            );
          let simpleI = sketch.map(i, 0, mirroredSpect.length - 1, 0, 360);
          let x = r * sketch.cos(simpleI);
          let y = r * sketch.sin(simpleI);
          sketch.vertex(x, y);
        }
        sketch.endShape();

        sketch.pop();
      };
    },
  },
};
</script>

<template>
  <div ref="p5" class="p5vue"></div>
</template>

<style lang="scss">
.p5vue {
  position: relative;
  width: 100%;
  margin: 4rem 0;
}

.p5Canvas {
  width: 100%;
  height: auto;
}
</style>
